// 引入qs
import Qs from 'qs';
import axios from "axios";
import {dns} from "@/utils/dns.js"
// 引入ui组件
// 请求默认地址
axios.defaults.baseURL = dns;
// 设置请求超时
axios.defaults.timeout = 10000;

// 设置请求拦截器（在请求发送出去之前 带上一些东西）
axios.interceptors.request.use(config => {
  // 每次发送请求前判断token，存在就在header加上token，如果过期所以在响应拦截器中要对返回状态进行判断
  // const token = localStorage.token
  // token && (config.headers.Authorization = token)
  return config;
}, err => Promise.reject(err))

// 设置响应拦截器 在接收到后端的响应结果以后 统一处理
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功
    if (response.status === 200) {
      if (response.data.code > 0) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(response)
      }
    } else {
      return Promise.reject(response)
    }
  }, 
  error => {
    if (error.response.status) {
      // switch (error.response.status) {
      //   case 401:
      //     break
      //   case 403:
      //     break
      //   default:
      //     break
      // }
      return Promise.reject(error)
    }
  }
)

// 封装get方法
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, Qs.stringify(params))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}